import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useVersionStore = defineStore("version", () => {
  // State
  const _version = ref<string>("1.0.0");

  // Getters
  const version = computed(() => _version.value);

  // Actions
  const setVersion = (newVersion: string) => {
    _version.value = newVersion;
  };

  return {
    version,
    setVersion,
  };
});
